<template>
	<v-dialog v-model="visible" persistent>
		<v-card>
			<v-card-title class="text-h5 grey lighten-2">
				Términos y condiciones
			</v-card-title>
			<v-card-text>
				<v-expand-transition>
					<v-row v-show="generandoContrato">
						<v-col cols="12" class="d-flex justify-center">
							<v-progress-circular :size="150" :width="15" indeterminate color="primary"/>
						</v-col>
						<v-col cols="12" class="text-center">
							Generando contrato...
						</v-col>
					</v-row>
				</v-expand-transition>
				<v-row v-show="!generandoContrato && hayContrato">
					<v-col cols="12">
						<div class="text-justify pa-1 black--text" v-html="contrato">
							<!-- Contrato va acá, en HTML -->
						</div>
					</v-col>
					<v-col cols="12">
						<v-alert outlined type="info" class="my-1" text icon="sentiment_very_satisfied">
							Después que validemos el pago, enviaremos vía e-mail una copia de este contrato y toda la información
							para comenzar a operar con los productos contratados.
						</v-alert>
					</v-col>
				</v-row>
			</v-card-text>
			<v-divider></v-divider>
			<v-card-actions class="d-flex justify-end">
				<v-btn @click="aceptar" color="primary" depressed class="ma-1" large
					:disabled="generandoContrato || !hayContrato">
					<v-icon left>
						done
					</v-icon>
					Aceptar y pagar
				</v-btn>
				<v-btn @click="rechazar" text depressed class="ma-1" large>
					<v-icon left>
						close
					</v-icon>
					Cerrar
				</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
import { API } from 'aws-amplify';
import * as config from '@/config';

let contadorGeneracionContrato = 0;

export default {
	props: {
		'datos-plan': {
			type: Object,
			default: {},
		},
		'datos-cliente': {
			type: Object,
			default: {},
		},
		'datos-adicionales': {
			type: Object,
			default: {},
		},
		'cupon': {
			type: String,
			default: undefined,
		},
		'visible': {
			type: Boolean,
			default: false,
		},
	},
	data: () => ({
		generandoContrato: false,
		contrato: undefined,
	}),
	computed: {
		hayContrato: function() {
			let vm = this;
			let hay = (vm.contrato !== undefined);
			return hay;
		},
	},
	methods: {
		generarContrato: async function() {
			// Podrían haber varias invocaciones de esta función en paralelo. Asignar a cada invocación un identificador único, lo cual
			// permite mostrarle al usuario solo el resultado de la última invocación.
			let vm = this;
			let identificadorInvocacion = ++contadorGeneracionContrato;
			vm.contrato = undefined;
			if((vm.datosPlan === undefined) || (vm.datosCliente === undefined)) {
				vm.notificar('Para generar el contrato se requiere de un plan y los datos del cliente', 'error');
				return;
			}
			let apiName = config.autocontratarApiName;
			let path = '/generar-contrato';
			let datosPlan = vm.datosPlan;
			let datosAdicionales = vm.datosAdicionales;
			let datosCliente = vm.datosCliente;
			let cupon = vm.cupon;
			let init = {
				headers: {},
				body: {
					datosPlan,
					datosAdicionales,
					datosCliente,
					cupon,
				},
			};
			vm.generandoContrato = true;
			try {
				let response = await API.post(apiName, path, init);
				if(identificadorInvocacion !== contadorGeneracionContrato) { return; } // Inhibir, simular que aún se está generando.
				vm.contrato = response.contrato;
			}
			catch(e) {
				if(identificadorInvocacion !== contadorGeneracionContrato) { return; } // Inhibir, simular que aún se está generando.
				vm.notificar(`Error al generar contrato. Intente recargar esta página.`, 'error');
			}
			vm.generandoContrato = false;
		},
		notificar: function(mensaje, tipo) {
			let vm = this;
			vm.$emit('notificacion', {mensaje, tipo});
		},
		aceptar: function() {
			let vm = this;
			vm.$emit('acepta');
		},
		rechazar: function() {
			let vm = this;
			vm.$emit('rechaza');
		},
	},
	watch: {
		visible: {
			immediate: true,
			handler: function(newVal) {
				let vm = this;
				if(newVal) {
					vm.generarContrato();
				}
			}
		},
	}
};
</script>
